import { Box, Flex, Text } from '@mantine/core';

interface IPropsContextInfo {
  companyName: string;
  fileName: string;
}

export default function ContextInfo(props: IPropsContextInfo) {
  const { companyName, fileName } = props;
  return (
    <Flex
      gap="md"
      style={(theme) => ({
        border: `1px solid ${theme.colors.gray[3]}`,
        backgroundColor: theme.colors.gray[0],
        borderRadius: theme.radius.sm,
        padding: theme.spacing.sm,
      })}
    >
      <Box>
        <Text size="xs" c="gray.6">
          거래처명
        </Text>
        <Text fw={500}>{companyName || '-'}</Text>
      </Box>
      <Box>
        <Text size="xs" c="gray.6">
          파일명
        </Text>
        <Text fw={500}>{fileName || '-'}</Text>
      </Box>
    </Flex>
  );
}
